export default "__VITE_ASSET__558448fa__"